module.exports = __webpack_public_path__ + "static/media/close_twilio_phone.fa8c6158.svg";